<template>
  <div class="col-span-6 sm:col-span-4">
    <tec-label :for="id" :value="label" />
    <tec-input
      :id="id"
      ref="input"
      :name="name"
      :type="type"
      :value="modelValue"
      class="mt-1 block w-full"
      :class="{ 'border-red-500': error }"
      @input="$emit('update:modelValue', $event.target.value)"
    />
    <tec-input-error v-if="error" :message="error" class="mt-2" />
  </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid';
import TecLabel from '@/Jetstream/Label';
import TecInput from '@/Jetstream/Input';
import TecInputError from '@/Jetstream/InputError';

export default {
  emits: ['update:modelValue'],
  components: { TecLabel, TecInput, TecInputError },
  props: {
    id: {
      type: String,
      default() {
        return uuidv4();
      },
    },
    type: {
      type: String,
      default: 'text',
    },
    modelValue: String,
    label: String,
    error: String,
    name: String,
  },
  methods: {
    focus() {
      this.$refs.input.focus();
    },
    select() {
      this.$refs.input.select();
    },
    setSelectionRange(start, end) {
      this.$refs.input.setSelectionRange(start, end);
    },
  },
};
</script>
